import type {SchemeLogoProps} from '../../CreditCardSchemeLogo.tsx';

export function VisaLogo({className, color = '#FFFFFF'}: SchemeLogoProps) {
    return (
        <svg
            aria-label="Visa"
            className={className}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.224 16.524L11.94 31.516H7.84L4.748 19.55C4.56 18.814 4.398 18.544 3.826 18.234C2.894 17.728 1.354 17.254 0 16.958L0.092 16.524H6.692C7.1233 16.5236 7.54054 16.6773 7.86842 16.9575C8.19629 17.2377 8.41321 17.6259 8.48 18.052L10.114 26.728L14.15 16.524H18.224ZM34.29 26.622C34.306 22.664 28.818 22.446 28.856 20.678C28.868 20.14 29.38 19.568 30.5 19.422C31.8126 19.2974 33.1345 19.5295 34.326 20.094L35.006 16.914C33.8459 16.4779 32.6173 16.2524 31.378 16.248C27.544 16.248 24.846 18.288 24.822 21.206C24.798 23.364 26.748 24.566 28.218 25.286C29.73 26.02 30.238 26.492 30.23 27.148C30.22 28.156 29.026 28.598 27.91 28.616C25.96 28.646 24.83 28.09 23.926 27.67L23.224 30.954C24.13 31.37 25.802 31.734 27.536 31.75C31.61 31.75 34.276 29.738 34.29 26.622ZM44.412 31.516H48L44.87 16.524H41.558C41.2041 16.5207 40.8574 16.6239 40.5629 16.82C40.2683 17.0161 40.0394 17.2962 39.906 17.624L34.088 31.516H38.16L38.97 29.276H43.946L44.412 31.516ZM40.086 26.204L42.126 20.574L43.302 26.204H40.086ZM23.766 16.524L20.56 31.516H16.68L19.89 16.524H23.766Z"
                fill={color}
            />
        </svg>
    );
}
